import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from 'components/shadcn/ui/dialog';
import { Button } from 'components/shadcn/ui/button';

const WARNING_SECONDS = 60;

export const SessionExpiryModal = ({ open, onStaySignedIn, onSignOut }) => {
    const [secondsLeft, setSecondsLeft] = useState(WARNING_SECONDS);

    useEffect(() => {
        if (!open) {
            setSecondsLeft(WARNING_SECONDS);
            return;
        }

        const interval = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [open]);

    const minutes = Math.floor(secondsLeft / 60);
    const seconds = String(secondsLeft % 60).padStart(2, '0');
    const countdown = `${minutes}:${seconds}`;

    return (
        <Dialog
            open={open}
            onOpenChange={(isOpen) => {
                if (!isOpen) onStaySignedIn();
            }}
        >
            <DialogContent
                className="sm:max-w-sm"
                onPointerDownOutside={(e) => e.preventDefault()}
            >
                <DialogHeader className="gap-3 text-center sm:text-center">
                    <div className="flex items-center justify-center gap-2">
                        <Clock className="h-5 w-5 text-accent" />
                        <DialogTitle>Session Expiring</DialogTitle>
                    </div>
                    <DialogDescription className="text-secondary">
                        You will be signed out in{' '}
                        <strong className="text-accent">{countdown}</strong> due
                        to inactivity.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 sm:justify-evenly">
                    <Button
                        variant="outline"
                        onClick={onStaySignedIn}
                        className="bg-muted text-slate-500 hover:bg-slate-300 hover:text-foreground dark:hover:bg-slate-900/50"
                    >
                        Stay Signed In
                    </Button>
                    <Button
                        variant="outline"
                        onClick={onSignOut}
                        className="text-slate-500 hover:text-foreground"
                    >
                        Sign Out Now
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
